import { render, staticRenderFns } from "./invoices-profit.vue?vue&type=template&id=20d4fbe0&scoped=true"
import script from "./invoices-profit.vue?vue&type=script&lang=js"
export * from "./invoices-profit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4fbe0",
  null
  
)

export default component.exports